import { AsyncStatus } from "../redux/base.state";
import {
  FiltersData,
  GeneralFiltersData,
  SelectedFilters,
} from "./filters.types";

export interface FiltersState {
  data: FiltersData | null;
  generalData: GeneralFiltersData | null;
  status: AsyncStatus;
  generalStatus: AsyncStatus;
  error: string | null;
  /** Kullanıcının/URL'in seçtiği filtreler (init kaynağı, URL sync). */
  selected: SelectedFilters;
  /** Backend'in döndürdüğü seçili değerler — checkbox checked + fetch payload buradan. */
  serverSelected: SelectedFilters;
  /** Backend ilk filtre yanıtını döndürdü mü? true ise serverSelected fetch kaynağıdır. */
  serverSelectedReady: boolean;
  /** serverSelected HANGİ slug için üretildi. Slug reuse'da stale serverSelected'ın
   *  yeni slug'a sızmasını engeller — effectiveSelected bu slug eşleşirse serverSelected kullanır. */
  serverSelectedSlug: string | null;
  /** Sadece kullanıcı toggle/etkileşiminde artar — fetch'i tetikleyen sayaç.
   *  Backend yanıtı serverSelected'ı değiştirse de bu değişmez → gereksiz fetch/döngü engellenir. */
  userInteractionCount: number;
  /** Sayfa açılışında URL'de AÇIKÇA yazan filtre key'leri (useFilterUrlSync init'i yazar).
   *  getFilters yanıtındaki bağlam merge'ü bu key'lere DOKUNMAZ: remount'ta
   *  userInteractionCount 0'a düştüğü için backend'in bağlam değeri (ör. /kadin
   *  menüsünün gender'ı) URL'deki kullanıcı seçimini (?gender=7) eziyordu. */
  urlOwnedKeys: (keyof SelectedFilters)[];
  /**
   * Sayfa BAĞLAMI kategori/ürün grubu/alt kategori gruplarından en az birini
   * seçili getirdi mi (slug kontrolü ya da getFilters yanıtı).
   *
   * "En az bir seçili kalmalı" kuralı yalnızca bu true iken çalışır. Bağlamsız
   * bir listede (ör. tüm ürünler) kullanıcı kendi eliyle bir kategori seçip
   * sonra kaldırdığında kaldırabilmeli — orada korunacak bir bağlam yok, uyarı
   * vermek kullanıcıyı kendi seçiminde hapsetmek olurdu.
   *
   * Yalnızca bağlam yazan yollar (setSelected init'i + getFilters bağlam
   * merge'ü) set eder; kullanıcı toggle'ları DOKUNMAZ.
   */
  guardedContextSeeded: boolean;
}

export const defaultSelected: SelectedFilters = {
  gender: [],
  category: [],
  category_groups: [],
  category_sub_groups: [],
  product: [],
  color: [],
  size: [],
  brand: [],
  season: [],
  seller_badge: [],
  rating: [],
  discounted: false,
  new_products: false,
  coupon: false,
  bulk_sale: false,
  price: {},
  sort: "default",
  special_filters: [],
};
